import store from './../../store';
import React from 'react';
import Utils from 'src/utils/Utils';
import UtilsPagos from '../../utils/payway/UtilsPagos';
import UtilsIpTelmex from '../../utils/user/IpTelmex';
import DeviceStorage from './../../components/DeviceStorage/DeviceStorage';
import { AAF_MODAL_ERROR, HIDE_MODAL } from '../../actions/modal';
import { showModal, MODAL_SUCCESS } from '../../actions/modal';
import { playFullMedia} from '../../actions/playmedia';
import { HTTP_METHOD_GET, HTTP_METHOD_POST, PAYMENT_INPUT_STYLE_OUTFOCUS,
  TRANSACTION_COMPONENT_CHECKOUT,
  TRANSACTION_COMPONENT_LANDING,
  TRANSACTION_COMPONENT_PLAN_SELECTOR,
  TRANSACTION_COMPONENT_TICKET,
  TRANSACTION_COMPONENT_UPSELL,
  TRANSACTION_COMPONENT_VCARD } from './constants';
import { fetchIsLoggedIn, receiveIsLoggedIn, receiveSubscription } from '../../reducers/user';
import { fetchLinealChannels } from '../../actions/payway';
import { paywayConfirm, changePaymentInfo } from '../../requests/loader';
import settings from '../../devices/all/settings';
import Translator from './../../requests/apa/Translator';
import { TransactionDetailType } from 'packages/components/lib/TransactionDetail';

export async function apiPaywayConfirm(Data) {

  const { pbi = {}, wfs = {},  wfs:{buyLink = ''} = {} ,formParams = {}, extra = {}, showError = true } = Data;
  const request = Utils.getRequest(buyLink);
  const http_method = getHTTPMethod(buyLink);
  let params = {};
  let postData = {};
  if (http_method === HTTP_METHOD_GET) {
    const { buylink } = request.params;
    request.params = { ...request.params, ...formParams, buylink };
  } else if (http_method === HTTP_METHOD_POST) {
    postData = getPostData(request, wfs, formParams, extra);
    params = request.params;
  }
  params = getAccessCodePin(pbi, request.params);
  request.params = getAccessCodePin(pbi, request.params);

  return paywayConfirm(request.uri, params, http_method, postData, showError);
}

function getHTTPMethod(buyLink) {
  return (buyLink.includes("payway/confirm") || buyLink.includes("payway/v1/confirm")) ? HTTP_METHOD_GET : HTTP_METHOD_POST;
}

function getPostData(request, worfFlowSelected, formParams, extra) {

  return {
    payway: request.params.payway,
    buyToken: worfFlowSelected.buyToken,
    extra_params: JSON.stringify(formParams),
    ...extra
  };

}

function getAccessCodePin(pbi, params) {

  const { accessCodePin = false } = pbi;

  if (accessCodePin) {
    return { ...params, accessCodePin }
  }

  return params;

}

export function isSubscription(pbi) {
  const { oneoffertype = '' } = pbi
  return oneoffertype.includes('subscrition');
}

export function onPaymetSuccess(resp, pbi, wfs, gateway, redirectCB, fromModal = true) {
  if (pbi.isSubscription) {
    registerSubscription(resp, pbi, redirectCB);
  }
  else {
    showPaymentSuccess(resp, pbi, gateway, redirectCB, fromModal);
  }
}

function showPaymentSuccess(resp, pbi, gateway, redirectCB, fromModal) {

  const { groupId = false, oneoffertype, isLive } = pbi;
  const oneClicKey = `${oneoffertype}_${gateway}`;
  const { response: { payway_token = '' } = {} } = resp;

  const isOneClicFlow = groupId ? true: false;

  if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
    if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
      redirectPlayerOneClic(groupId, isLive, payway_token, redirectCB);
    }
    else{
      redirectCB && redirectCB(resp);
    }
  }
  else {
    redirectCB && redirectCB(resp);
      // fromModal ?
      //   redirectCB && redirectCB() :
      //   showSuccessModal(resp, () => validateMail(isOneClicFlow, oneClicKey, redirectCB, pbi), pbi);
  }
}

function validateMail(isOneClicFlow, oneClicKey, redirectCB, pbi) {

  const { groupId } = pbi;
  const { user: { session_userhash } = {} } = store.getState();

  UtilsIpTelmex.validateMail(session_userhash).then((resp) => {

    if (!resp.validEmail) {

      const detail = {
        isAlertVisible: true,
        alertAction: ALERT_ACTION_IPTELMEX
      };

      document.dispatchEvent(new CustomEvent(settings.show_head_band, { detail }));
    }

    if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
      redirectPlayerOneClic(groupId, backToLive, payway_token, redirectCB);
    }
    else {
      redirectCB && redirectCB();
    }
  });
}

function getOkBtnTextKey(producttype){

  let okBtnTextKey = 'payway_confirm_{provider}_ok';

  if (producttype.includes('CV_')) {
    okBtnTextKey = okBtnTextKey.replace('{provider}', 'cv');
  }
  else {
    okBtnTextKey = okBtnTextKey.replace('{provider}', producttype.toLowerCase());
  }

  return okBtnTextKey;
}


export function registerSubscription(resp, pbi, redirectCB) {

  const { producttype = '' } = pbi || {};
  let suscription = {};
  const okBtnTextKey = getOkBtnTextKey(producttype);

  store.dispatch(fetchIsLoggedIn());

  if (producttype.includes('CV_')) {
    const { user: { session_userhash } = {} } = store.getState();
    suscription = { AMCO: true };
    DeviceStorage.setItem('user_hash', session_userhash);
  }
  else {
    if (producttype) {
      suscription[producttype] = true;
    }
  }

  const { user: { user_id } = {} } = store.getState();

  store.dispatch(fetchLinealChannels(user_id, () => {
    redirectCB && redirectCB(resp);
  }));

  store.dispatch(receiveSubscription(suscription));
  const { user } = store.getState();
  store.dispatch(receiveIsLoggedIn(user));
}

export function redirectPlayerOneClic(gid, islive = false, payway_token = null, redirectCB, redirectCBOnLive) {

  if(!islive) {
    setTimeout(() => {
      redirectCB && redirectCB();
    }, 500);
  } else {
    redirectCBOnLive && redirectCBOnLive();
  }

  const newChannel = {
    playerstate: 'PLAYING',
    source: {
      videoid: gid
    },
    size: {
      top: 0,
      left: 0,
      width: 1280,
      height: 720,
    },
    ispreview: false,
    islive,
    ispip: false,
    event: null,
    payway_token,
  };
  store.dispatch(playFullMedia(newChannel));
}

function showSuccessModal(resp, callback, pbi) {


  const { producttype = '' } = pbi || {};
  const { user: { username = '' } = {} } = store.getState();
  const { response: { code = false, msg = '' } } = resp;
  //const okBtnTextKey = getOkBtnTextKey(producttype)
  const okText = Translator.get('btn_confirm_payment_ok', 'Aceptar');

  let content = msg;

  if (code) {
    content = Translator.get(code, code);
  }

  const modal = {
    modalType: MODAL_SUCCESS,
    modalProps: {
      callback,
      from: 'payment',
      replaces: {
        '{@EMAIL}': username
      },
      content,
      okText: okText,
      asset: 'ic_modal_success',
    }
  };

  store.dispatch(showModal(modal));
}


export function showError(err, callback) {

  console.error('[AAF Payment]', err)

  const modal = {
    modalType: AAF_MODAL_ERROR,
    modalProps: {
      callback,
      content: err
    }
  };

  store.dispatch(showModal(modal))
}

export function getWorkflow(gateway, worflowstart) {
  const { list } = worflowstart;
  if (list && list.length > 0) {
      return list.find((i) => i.gateway === gateway);
  }
  if(list && list.listBuyLinks) {
    return list.listBuyLinks.find((i) => i.gateway === gateway);
  }

  return undefined;
}

export function getNumberLength() {
  const phoneLength = Utils.getApaMetadataKey('regional_parameters', '{"phone_length": 10}');
  return Number(phoneLength.phone_length);
}

export function GetRegExpMovil() {
  switch (DeviceStorage.getItem('region')) {
    case 'argentina':
      return null;
    case 'costarica':
      return /^\d{8}$/;
    case 'mexico':
      return /^\d{10}$/;
    default:
      return /^\d+$/;
  }
}

/**
 *
 * @param {*} Data contains extra_params
 * @returns api to update payment information
 */
export function apiChangePaymentInfo(Data) {
  const { formParams = {} } = Data;
  const params = {
    extra_params: JSON.stringify(formParams),
  };
  return changePaymentInfo(params);
}

/**
 *
 * @param {string} element
 */
export function setInitialFocus(element, withDelay = true) {
  if(withDelay){
    setTimeout(() => {
      window.SpatialNavigation.focus(element);
    }, 100);
  }
  else{
    window.SpatialNavigation.focus(element);
  }
}

/**
 * Single element input
 * @param {Array} elements array of id's
 */

export function onFocusElement(elements) {
  elements.forEach(e => {
    if (document.activeElement.className.includes('aaf_keyboard')) {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.border = PAYMENT_INPUT_STYLE_OUTFOCUS;
      }
    } else {
        if (document.getElementById(e.id)) {
          document.getElementById(e.id).style.border = '';
        }
    }
  });
}

/**
 * Multiple elements input
 * @param {Array} elements array objects of inputs
 */
export function onFocusMultipleElements(elements) {
  elements.forEach(e => {
    if (document.activeElement.className.includes('aaf_keyboard')) {
      if (document.getElementById(e.id) && e.activeElement) {
        document.getElementById(e.id).style.border = PAYMENT_INPUT_STYLE_OUTFOCUS;
      }
      if (document.getElementById(e.id) && !e.activeElement) {
        document.getElementById(e.id).style.border = '';
      }
    } else {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.border = '';
      }
    }
  });
}

/**
 *
 * @param {*} data object data modal
 * @returns object to render modal type (subscription, rent or buy)
 */
export function handleTypeModal(data) {
  const { type, total, duration, frequency, days, content, payment_method, payment_method_key, img_largeSub, img_large, providerImage, title, next_pay, from, pbi, labelPaymentMethod, contentTitle} = data;
  const { currency, price, periodicity, oneoffertype, producttype, bonus, family } = pbi || {};
  const ticketPrice = getTransactionalPrice({currency, price, component:TRANSACTION_COMPONENT_TICKET});
  const ticketTax = getTransactionalTax({ periodicity, frequency, oneoffertype, producttype, component: TRANSACTION_COMPONENT_TICKET, next_pay });
  const ticketBonus = getTransactionalBonus({ component: TRANSACTION_COMPONENT_TICKET, bonus, producttype, family });
  const ticketPriceTax = {
    key: `${ticketPrice.key},${ticketTax.key}`,
    label: `${ticketPrice.label} ${ticketTax.label}`.trim()
  };
  let element = {};

  switch (type) {
      case TransactionDetailType.SUSCRIPTION:
          element = {
              ticketPriceTax,
              ticketBonus,
              total: total,
              duration: duration,
              days: days,
              content: content,
              payment_method: payment_method,
              payment_method_key: payment_method_key,
              next_pay: next_pay,
              img_large: img_largeSub,
              providerImage: providerImage,
              type: 'subscription',
              from,
              labelPaymentMethod
          };
      break;
      case TransactionDetailType.RENT_MOVIE:
          element = {
              ticketPriceTax,
              title: title || '',
              total: total,
              duration: duration,
              frequency: frequency,
              payment_method: payment_method,
              next_pay: next_pay,
              payment_method_key: payment_method_key,
              img_large: img_large || '',
              type: 'rent',
              from,
              labelPaymentMethod,
              contentTitle
          };
      break;
      case TransactionDetailType.BUY_SEASON:
      case TransactionDetailType.BUY_EPISODE:
      case TransactionDetailType.BUY_MOVIE:
          element = {
              ticketPriceTax,
              title: title || '',
              total: total,
              payment_method: payment_method,
              img_large: img_large || '',
              type: 'buy',
              from,
              labelPaymentMethod,
              contentTitle
          };
      break;
      default:
          element = {};
  }
  return element;
};

export function filterInputValue(value, type) {
  switch (type) {
    case 'name':
    case 'direction':
    case 'city':
      return value;
    case 'code':
    case 'validation_code':
      return value.split('').filter((character) => character.match(/[a-zA-Z0-9]/)).join('')
    default:
      return value.split('').filter((character) => character.match(/\d/)).join('')
    }
}

export function isModalHide() {
  const state = store.getState();
  return (
    state.modal.modalType === null || state.modal.modalType === HIDE_MODAL
  );
}

/**
 * @returns time to hide a modal notification
 */
export function alertHideTime() {
  const timer = Utils.getApaMetadataKey('alert_autoHideTime', '{"default": {"time": 3}}');
  return timer.default.time;
}

export const getTransactionalLabels = () => {
  return {
    textTrial: Translator.get('subscription_tryInvite_description_label_1', ''),
    textCost: Translator.get('subscription_tryInvite_description_label_2', 'sin costo'),
    textSeparator: Translator.get('subscription_periodicity_month_label_1', ''),
    textTax: Translator.get('subscription_costTaxIcluded_complement_label_1', ''),
    textTryInviteComplement: Translator.get('subscription_tryInvite_complement_label_1', 'después'),
    textTryInviteDescription: Translator.get('subscription_tryInvite_description_label_3', ''),
    textNoBonus: Translator.get('noBonus_subscriptionDescription_subscription_label', ''),
    textSlashLanding: Translator.get('price_subscriptionDescription_slash_label', ''),
  }
}

export const getAndroidTvPolicesLabels = () => {
  return {
    title: Translator.get('android_message_payway_policies_title', 'ESTIMADO USUARIO'),
    description: Translator.get('android_message_payway_policies_description', 'Estás a un paso de disfrutar tu contenido seleccionado. Entra a clarovideo.com  para finalizar tu proceso de compra.'),
  }
}

export const getAddonAndroidMessageClassNames = (labels, classes) => {
  return (
    <div className={classes.classNameContainer}>
        <div className={classes.classNameTitle}>{labels.title}</div>
        <span className={classes.classNameDescription}>{labels.description}</span>
    </div>
  )
}


export const getTransactionalPrice = ({component='default', currency = '', price = '' }) =>{

  let result = {
    key: '',
    label: ''
  };

  switch (component){
    case TRANSACTION_COMPONENT_PLAN_SELECTOR:
    case TRANSACTION_COMPONENT_LANDING:
    case TRANSACTION_COMPONENT_CHECKOUT:
    case TRANSACTION_COMPONENT_TICKET:
    case TRANSACTION_COMPONENT_VCARD:
    case TRANSACTION_COMPONENT_UPSELL:
      result = {
        key: `pbi.currency,pbi.price`,
        label: `${currency}${price}`,
        currency: currency,
        price: price
      };
      break;
    default:
      break;
  }

  if (Utils.isNullOrUndefined(currency) || currency === '' ||
      Utils.isNullOrUndefined(price) || price === ''){
        result.label = '';
  }

  return result;

}

export const getTransactionalTax = ({component='default', producttype, periodicity, oneoffertype, frequency, next_pay='' }) => {
  const slashKey = `subscription_${producttype}_periodicitySeparator_${periodicity}_label`,
    slashLabel = Translator.get(slashKey, '');
  let periodicityKey = `subscription_${producttype}_${periodicity}_label`,
    periodicityLabel = Translator.get(periodicityKey, '');
  let taxKey = `${producttype}_subscriptionDescription_costTaxIncluded_label`;
  let taxLabel = Translator.get(taxKey, '');

  switch (component){
    case TRANSACTION_COMPONENT_PLAN_SELECTOR:
    case TRANSACTION_COMPONENT_LANDING:
      return {
        key:`${slashKey},${periodicityKey},${taxKey}`,
        label:`${slashLabel} ${periodicityLabel} ${taxLabel} `.trim(),
        labelPeriodicity: `${slashLabel} ${periodicityLabel}`.trim(),
        labelTax: `${taxLabel}`.trim()
      }
    case TRANSACTION_COMPONENT_CHECKOUT:
      if (oneoffertype === 'subscrition'){
        //SUSCRIPCION
        return {
          key:`${slashKey},${periodicityKey},${taxKey},`,
          label: `${slashLabel} ${periodicityLabel} ${taxLabel}`.trim()
        }

      } else {
        //RENTA & EPISODIO
        periodicityLabel = Translator.get(periodicity, '');
        const frequencyKey = 'pbi.frequency';
        return {
          key:`${slashKey},${frequencyKey},${periodicityKey},${taxKey}`,
          label: `${slashLabel} ${frequency == '0' ? ``: `${frequency} ${periodicityLabel}`} ${taxLabel}`.trim()
        }
      }
      case TRANSACTION_COMPONENT_TICKET:


        return {
          key:` ${slashKey}, ${periodicityKey}, ${taxKey}`,
          label: `${slashLabel} ${periodicityLabel} ${taxLabel}`.trim()
        }
      case TRANSACTION_COMPONENT_UPSELL:
        let labelPeriodicity = periodicityLabel;

        if (next_pay !== '' && next_pay !== undefined) {
          labelPeriodicity = '';
        }

        return {
          key:`${taxKey}, ${slashKey}, ${periodicityKey}`,
          label: `${slashLabel} ${next_pay} ${labelPeriodicity} ${taxLabel}`.trim()
        }
      case TRANSACTION_COMPONENT_VCARD:
        return {
          key:`${slashKey},${periodicityKey},${taxKey},`,
          label: `${slashLabel} ${periodicityLabel} ${taxLabel}`.trim()
        }
      default:
      return {
        key:`${taxKey}`,
        label: `${taxLabel}`.trim()
      }
  }
}

export const getTransactionalBonus = ({ component='default', bonus, producttype, family, offerid = '', provider = '' }) => {
  let textTrialKey= '', bonusKey = bonus;
  let textTrialLabel = '', bonusLabel = Translator.get(bonusKey, '');
  let result = {
    key:'',
    label:''
  };

  if(!bonus){
    return result;
  }

  switch (component){
    case TRANSACTION_COMPONENT_PLAN_SELECTOR:
      textTrialKey = `transactional_${bonus}_subscription_plan_tryInvite_description`;
      textTrialLabel = Translator.get(textTrialKey, '');
      /**
       * *La concatenación de textos se debe mostrar, solo si la llave existe y tiene valor
       * Prefijo + Periodo de prueba
       * Prefijo : transactional_<bonus>_subscription_plan_tryInvite_description=”Disfruta”
       * Periodo de prueba: obtenido de bonus de PBI = bonus_rtveplay = “7 días sin costo”
       */

      result = {
        key:`${textTrialKey},${bonusKey}`,
        label: `${textTrialLabel} ${bonusLabel}`.trim()
      };
      break;
    case TRANSACTION_COMPONENT_LANDING:
      /**
       * * La key que trae el texto se debe mostrar, solo si la llave existe y tiene valor
       * * Texto de la Etiqueta: LandingComercial_Oferta_TextoPromocion_{producttype} = “Disfruta 7 días sin costo”
      */

      textTrialKey = `LandingComercial_Oferta_TextoPromocion_${producttype}`;
      textTrialLabel = Translator.get(textTrialKey, '');

      result = {
        key:`${textTrialKey},${bonusKey}`,
        label: `${textTrialLabel}`
      }
      break;
    case TRANSACTION_COMPONENT_CHECKOUT:
      /**
       * * La key que trae el texto se debe mostrar, solo si la llave existe y tiene valor
       * * Texto de la Etiqueta: Checkout_Transaccion_TextoPromocion_{producttype} = “Disfruta 7 días sin costo”
      */

      textTrialKey = `Checkout_Transaccion_TextoPromocion_${producttype}`;
      textTrialLabel =  Translator.get(textTrialKey, '');

      result = {
        key:`${textTrialKey},${bonusKey}`,
        label: `${textTrialLabel}`
      };
      break;
    case TRANSACTION_COMPONENT_TICKET:
      /**
       * * La key que trae el texto se debe mostrar, solo si la llave existe y tiene valor
       * * Texto de la Etiqueta: Ticket_Transaccion_TextoPromocion_{producttype} = “Disfruta 7 días sin costo”
      */

      textTrialKey = `Ticket_Transaccion_TextoPromocion_${producttype}`;
      textTrialLabel =  Translator.get(textTrialKey, '');

      result = {
        key:`${textTrialKey},${bonusKey}`,
        label: `${textTrialLabel}`
      };
      break;
    case TRANSACTION_COMPONENT_VCARD:
      /**
       * * La key que trae el texto se debe mostrar, solo si la llave existe y tiene valor
       * * Texto de la Etiqueta: FichaContenido_Comercial_TextoPromocion_${family} = “Disfruta en Claro Video”
      */

      textTrialKey = `FichaContenido_Comercial_TextoPromocion_${family}`;
      textTrialLabel =  Translator.get(textTrialKey, '');

      result = {
        key:`${textTrialKey},${bonusKey}`,
        label: `${textTrialLabel}`
      };
      break;
    case TRANSACTION_COMPONENT_UPSELL:
      /**
       * * La key que trae el texto se debe mostrar, solo si la llave existe y tiene valor
       * * Texto de la Etiqueta: ContratacionCanal_Transaccion_TextoPromocion_${family} = “Disfruta en Claro Video”
      */

      const keyOne = Translator.get(`ContratacionCanal_Transaccion_TextoPromocion_${family}`, '');
      const keyTwo = Translator.get(`ContratacionCanal_Transaccion_TextoPromocion_${offerid}`, '');
      const keyThree = Translator.get(`ContratacionCanal_Transaccion_TextoPromocion_${provider}`, '');
      const multiKeyPromotion = keyOne !== '' ? keyOne : keyTwo !== '' ? keyTwo : keyThree;
      const textPromotion = multiKeyPromotion;

      bonusKey = textPromotion;
      bonusLabel = textPromotion;

      result = {
        key:`${bonusLabel},${bonusKey}`,
        label: `${bonusLabel}`
      }
      break;
    default:
      result = {
        key: ``,
        label: ``
      }
      break;
    }

  if(!bonusLabel){
    return {
      key:`${bonusKey}`,
      label:''
    };
  }

    return result;
}


export const getTransactionalBonusComplement = ({component='default', bonus}) =>{


  let bonusKey = '';
  let bonusLabel = '';
  let result = {
    key:``,
    label: ``
  };

  switch (component){
    case TRANSACTION_COMPONENT_LANDING:
      bonusKey = `${bonus}_subscription_tryInvite_complement_label_1`;
      bonusLabel = Translator.get(bonusKey, '');
      result = {
        key:`${bonusKey}`,
        label: `${bonusLabel}`.trim()
      }
      break;
    default:
      break;
  }

  return result;
}




// WEBPACK FOOTER //
// ./src/payments/utils/Utils.js